import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[appAlphaNumericUnderscore]',
  standalone: false  //NOSONAR
})
export class AlphaNumericUnderscoreDirective {
  private el = inject(ElementRef);

  private regex = new RegExp(/^[a-zA-Z0-9_]*$/);
  private specialKeys: string[] = [
    'Backspace',
    'Tab',
    'Enter',
    'Shift',
    'Control',
    'ArrowLeft',
    'ArrowRight',
    'Delete'
  ];

  // Block invalid characters on keydown
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.includes(event.key)) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const next: string = current + event.key;

    if (!this.regex.test(next)) {
      event.preventDefault();
    }
  }

  // Block invalid characters on paste
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';

    if (this.regex.test(pastedData)) {
      this.el.nativeElement.value += pastedData;
    }
  }
}
